import script from "./DemandWidgetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DemandWidgetPage.vue?vue&type=script&setup=true&lang=js"

import "./DemandWidgetPage.vue?vue&type=style&index=0&id=a498a34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a498a34c"]])

export default __exports__